import TrendingRegionStats from './TrendingRegionStats';
import TrendingTopicsStats from './TrendingTopicsStats';

function TrendGraphs() {
  return (
    <div className="grid gap-6">
      <TrendingTopicsStats />
      <TrendingRegionStats />
    </div>
  );
}

export default TrendGraphs;
